import { render, staticRenderFns } from "./DesignRirekisho001PreviewDoc.vue?vue&type=template&id=0d7c0f96&scoped=true"
import script from "./DesignRirekisho001PreviewDoc.vue?vue&type=script&setup=true&lang=ts"
export * from "./DesignRirekisho001PreviewDoc.vue?vue&type=script&setup=true&lang=ts"
import style0 from "@/assets/scss/format-edit/design-rirekisho-001-preview.scss?vue&type=style&index=0&id=0d7c0f96&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7c0f96",
  null
  
)

export default component.exports